import { PromotionCodeComboBoxComponent } from './promotion-code-combo-box.component';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * プロモーションコードコンボボックスの値を管理するクラス
 *
 * @export PromotionCodeComboBoxModel
 * @class PromotionCodeComboBoxModel
 */
export class PromotionCodeComboBoxModel {

  public codeDiv: string = <string>'';
  public reserveNum1: string = <string>'';

  public codeList: Array<any>;

  public blank: boolean = <boolean>true;                                        // 先頭空白表示
  public latestInfo: boolean = <boolean>false;                                  // 最新情報表示

  public component: PromotionCodeComboBoxComponent;                             // コンボボックスインスタンス
  public completeUpdateFlg: boolean = <boolean>false;                           // コードリスト取得完了
  public setCodeValue: string = <string>'';                                     // 初期設定コード値
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>true;
  // コード区分初期化済フラグ
  public isInitCodeDiv: boolean = <boolean>false;
  // 初期設定インデックス
  public setSelectedIndex: number = <number>-1;


  /**
   * コンストラクタ。初期値の設定を行う
   *
   * @memberof PromotionCodeComboBoxModel
   */
  public PromotionCodeComboBoxManage() {
  }

  /**
   * コードリストを更新する
   *
   * @param {*} serverData 取得データ
   * @memberof PromotionCodeComboBoxModel
   */
  public updateCodeList(serverData: any): void {
    let tempDataList: Array<any> = new Array<any>();

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = new Array<any>();
      }
    }

    // 処理件数
    let index: number = <number>0;

    // 先頭空白追加
    if (this.blank) {
      tempDataList.splice(index, 0, this.getBlankObject('', ''));
      index += 1;
    }

    // 最新情報表示
    if (this.latestInfo) {
      tempDataList.push(index, 0, this.getBlankObject('*', '最新情報'));
      index += 1;
    }

    // コード+：+名称追加
    for (; index < tempDataList.length; index++) {
      tempDataList[index].CodeValueName = tempDataList[index].CodeValue + ':' + tempDataList[index].CodeName;
    }

    this.codeList = tempDataList;

    this.completeUpdateFlg = true;
    // 選択コードが設定されたら優先する
    if (PlessViewUtilsSub.isEmpty(String(this.setCodeValue))) {
      this.setCodeValue = this.codeList[0].CodeValue;                        // ★追加部分
    }
    this.component.updateSelectedCodeValue();
  }

  /**
   * 空白のオブジェクトを取得する
   *
   * @private
   * @param {string} codeValue
   * @param {string} codeName
   * @returns {*}
   * @memberof PromotionCodeComboBoxModel
   */
  private getBlankObject(codeValue: string, codeName: string): any {
    const ob: any = {};
    ob.CodeDiv = '';
    ob.CodeValue = codeValue;
    ob.CodeName = codeName;
    ob.CodeDivName = '';

    if (!PlessViewUtilsSub.isEmpty(String(codeValue)) && !PlessViewUtilsSub.isEmpty(String(codeName))) {
      ob.CodeValueName = codeValue + ':' + codeName;
    } else {
      ob.CodeValueName = codeValue + codeName;
    }
    ob.Reserve1 = '';
    ob.Reserve2 = '';
    ob.ReserveNum1 = '';
    ob.ReserveNum2 = '';
    ob.SortNum = '';
    ob.StartOrderCode = '';
    ob.EndOrderCode = '';

    return ob;
  }

}
